import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'AIJobsList',
  pure: false
})
export class AIJobsListFilter implements PipeTransform {
  transform(items: any[], filter: string): any {
    if (!items || !filter) {
        return items;
    }
    return items.filter(item => item.name.toUpperCase().indexOf(filter.toUpperCase()) !== -1);
  }
}
